import { APP_VERSION, GIT_SHA, BUILD_TIME } from './version.generated';

export interface VersionInfo {
  version: string;
  gitSha: string;
  buildTime: string;
}

export function getVersionInfo(): VersionInfo {
  return {
    version: APP_VERSION,
    gitSha: GIT_SHA,
    buildTime: BUILD_TIME,
  };
}

export { APP_VERSION, GIT_SHA, BUILD_TIME };

